import { render, staticRenderFns } from "./TransactionEvent.vue?vue&type=template&id=c47c93de&scoped=true&"
import script from "./TransactionEvent.vue?vue&type=script&lang=js&"
export * from "./TransactionEvent.vue?vue&type=script&lang=js&"
import style0 from "./TransactionEvent.vue?vue&type=style&index=0&id=c47c93de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47c93de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
